import Client from "./Client";
// import RequestList from "./RequestList";

const FaxesService = {
    url: 'admin/storage',
    getDefault(){
        return {
            id : undefined,
            name : undefined,
            caption : undefined,
            type : undefined,
            url : undefined,
            created_at : undefined
        }
    },

    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async uploadDocument(formData) {
        return await Client.post(`${this.url}/documents`, formData, {
            headers: {
                'Content-Type': `multipart/form-data`,
            }
        });
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async uploadAccountingReceipt(formData) {
        return await Client.post(`${this.url}/accounting-receipts`, formData, {
            headers: {
                'Content-Type': `multipart/form-data`,
            }
        });
    }
}

export default FaxesService